import React from 'react';
import Message from '../LoadingError/Error';
import Loading from '../LoadingError/Loading';
import Orders from './Orders';
import { useEffect } from 'react';
import { getAllOrders } from '../../service/OrdersService';
import { useState } from 'react';

const OrderMain = ({ user }) => {
  const [search, setSearch] = useState('');
  const [orders, setOrders] = useState();
  const [ordersFiltered, setOrdersFiltered] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    if (user) {
      getAllOrders()
        .then((orders) => {
          const inverseArray = [];
          orders.map((order) => inverseArray.unshift(order));
          setOrders(inverseArray);
          setLoading(false);
        })
        .catch((e) => setError);
    }
  }, [user]);

  useEffect(() => {
    if (orders) {
      setOrdersFiltered(
        orders.filter((order) => order.user.email.includes(search))
      );
    }
  }, [orders, search]);

  return (
    <section className='content-main'>
      <div className='content-header'>
        <h2 className='content-title'>Pedidos</h2>
      </div>

      <div className='card mb-4 shadow-sm'>
        <header className='card-header bg-white'>
          <div className='row gx-3 py-3'>
            <div className='col-6 mx-auto'>
              <input
                type='text'
                placeholder='Buscar...'
                className='form-control p-2'
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* <div className='col-lg-3 col-6 col-md-3'>
              <select className='form-select'>
                <option>Status</option>
                <option>Active</option>
                <option>Disabled</option>
                <option>Show all</option>
              </select>
            </div> */}
            {/* <div className='col-lg-2 col-6 col-md-3'>
              <select className='form-select'>
                <option>Show 20</option>
                <option>Show 30</option>
                <option>Show 40</option>
              </select>
            </div> */}
          </div>
        </header>
        <div className='card-body'>
          <div className='table-responsive'>
            {loading ? (
              <Loading />
            ) : error ? (
              <Message variant='alert-danger'>{error}</Message>
            ) : (
              <Orders orders={ordersFiltered} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderMain;
